export const safeJson = <T,>(raw: string): T | null => {
  try {
    return JSON.parse(raw) as T
  } catch (e) {
    console.error('[SSE] parse error', e)

    return null
  }
}
